import { useState, useEffect } from 'react';
import { Nav, Navbar, Container } from 'react-bootstrap';
import { execSeatableSql } from './seatable.js';

function NavHeader(props) {
    const [navExpanded, setNavExpanded] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        var sql;
        if (props.mode === 'Capability') {
            sql = `SELECT \`PageSection\`, \`2ndMenu\` FROM \`CapabilitySections\` WHERE \`Capability\` = '${props.capability}' AND \`2ndMenu\` IS NOT NULL`;
        } else if (props.mode === 'Company') {
            sql = `SELECT \`Menu Item\` FROM \`Company\` WHERE \`Menu Level\` = 'Company' AND \`Menu Item\` IS NOT NULL ORDER BY \`Rank\``;
        }
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          if (props.mode === 'Capability') {
            setData(rows && rows.results.map(e => {return {"menuPath": e.PageSection[0].display_value, "menuText": e["2ndMenu"]}}));
          } else if (props.mode === 'Company') {
            setData(rows && rows.results.map(e => {return {"menuPath": e["Menu Item"], "menuText": e["Menu Item"]}}));
          }
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.mode, props.capability]);

    return (
        <header className="nav-header">
            <Navbar collapseOnSelect expand="md" variant="dark" className="nav-section" onToggle={() => setNavExpanded(!navExpanded)}>
                <Nav style={{width: "50vw"}}>
                    <Nav.Link href="#top" className="nav-item ms-2 ms-md-5 fs-4 fw-bold "><span>{props.navBrand}</span></Nav.Link>
                </Nav>
                <Navbar.Toggle aria-controls="section-navbar-nav" className="ms-auto" ><i className={`bi ${navExpanded ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i></Navbar.Toggle>
                <Container fluid className="m-0 p-0">
                    <Navbar.Collapse id="section-navbar-nav">
                        <Nav className="ms-auto me-5" >
                            {data && data.map((row, index) => {
                                return (
                                    <Nav.Link key={index} href={`#${row.menuPath}`} className="nav-item"><span>{row["menuText"]}</span></Nav.Link>
                                )
                            })}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default NavHeader;